import { render, staticRenderFns } from "./StateEffect.vue?vue&type=template&id=6ba38727&scoped=true&"
import script from "./StateEffect.vue?vue&type=script&lang=ts&"
export * from "./StateEffect.vue?vue&type=script&lang=ts&"
import style0 from "./StateEffect.vue?vue&type=style&index=0&id=6ba38727&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba38727",
  null
  
)

export default component.exports